import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';

// `eager`: títulos dos manifestos no ⌘K e no breadcrumb antes de a tela abrir (A07).
registerModuleCatalog('dataprev-employee', (locale) => import(`./locales/${locale}.po`), { eager: true });

/** Carrega o catálogo do módulo no idioma ativo (as rotas chamam antes de desenhar a tela). */
export const loadDataprevEmployeeMessages = () => ensureModuleMessages('dataprev-employee');
